<template>
  <!-- <v-footer dark padless>
    <v-card flat tile class="white--text text-center footer-card">
      <v-card-text class="white--text pt-0">
        <v-row justify="space-around" id="container" ref="container">
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address1"></div>
            <v-divider></v-divider>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address2"></div>
            <v-divider></v-divider>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address3"></div>
            <v-divider></v-divider>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center pa-5">
            <div v-html="getFooterDetails.address4"></div>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode1"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode1
              "
              height="250"
              contain
            />
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode2"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode2
              "
              height="250"
              contain
            />
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode3"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode3
              "
              height="250"
              contain
            />
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" sm="3" md="3" class="text-center">
            <img
              v-if="getFooterDetails.qrcode4"
              alt="QR code"
              :src="
                imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode4
              "
              height="250"
              contain
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="pa-0 white--text">
        <v-breadcrumbs
          :items="menus"
          divider="-"
          class="justify-center white--text breadcrum-color"
          color="white"
        ></v-breadcrumbs>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text text-center">
        {{ new Date().getFullYear() }} — <strong>Sivakasicrackersz</strong>
      </v-card-text>
    </v-card>
  </v-footer> -->

  <v-footer color="black" padless class="footer-black white--text">
    <v-card-text class="white--text pt-0">
      <v-row justify="space-around" id="container" ref="container">
        <v-col cols="12" sm="3" md="3" class="text-center pa-5">
          <div v-html="getFooterDetails.address1"></div>
          <v-divider></v-divider>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="12" sm="3" md="3" class="text-center pa-5">
          <div v-html="getFooterDetails.address2"></div>
          <v-divider></v-divider>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="12" sm="3" md="3" class="text-center pa-5">
          <div v-html="getFooterDetails.address3"></div>
          <v-divider></v-divider>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="12" sm="3" md="3" class="text-center pa-5">
          <div v-html="getFooterDetails.address4"></div>
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" sm="3" md="3" class="text-center">
          <img
            v-if="getFooterDetails.qrcode1"
            alt="QR code"
            :src="
              imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode1
            "
            height="250"
            contain
          />
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="12" sm="3" md="3" class="text-center">
          <img
            v-if="getFooterDetails.qrcode2"
            alt="QR code"
            :src="
              imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode2
            "
            height="250"
            contain
          />
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="12" sm="3" md="3" class="text-center">
          <img
            v-if="getFooterDetails.qrcode3"
            alt="QR code"
            :src="
              imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode3
            "
            height="250"
            contain
          />
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="12" sm="3" md="3" class="text-center">
          <img
            v-if="getFooterDetails.qrcode4"
            alt="QR code"
            :src="
              imageUrl + 'public/storage/qrcode/' + getFooterDetails.qrcode4
            "
            height="250"
            contain
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider color="white"></v-divider>
    <v-container fluid>
      <v-row class="py-6" align="stretch" justify="center">
        <v-col cols="12" sm="6" md="3" class="mb-4">
          <v-row align="center">
            <v-col cols="12" class="text-center">
              <v-img
                src="https://sivakasicrackersz.in/img/logo.c0143820.png"
                alt="Logo"
                max-width="120"
                class="mx-auto mb-2"
              />
              <div class="mb-1 white--text">
                <v-icon left color="white">mdi-phone</v-icon> +91 7200440049
              </div>
              <div class="mb-1 white--text">
                <v-icon left color="white">mdi-email</v-icon>
                sivakasicrackers65@gmail.com
              </div>
              <div class="white--text">
                <v-icon left color="white">mdi-map-marker</v-icon> 659/1,
                Marriyamman Nagar, Anuppankullam,<br />Sivakasi, Tamil Nadu -
                626189, India
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="mb-4">
          <h3 class="text-h6 mb-2 red--text">Quick Links</h3>
          <v-list
            dense
            nav
            class="nav-black white--text"
            style="background-color: black"
          >
            <v-list-item href="/termsandcondition" class="white--text">
              <v-list-item-title class="white--text"
                >Terms & Conditions</v-list-item-title
              >
            </v-list-item>

            <v-list-item href="/privacypolicy" class="white--text">
              <v-list-item-title class="white--text"
                >Privacy Policy</v-list-item-title
              >
            </v-list-item>

            <v-list-item href="/returnpolicy" class="white--text">
              <v-list-item-title class="white--text"
                >Return Policy</v-list-item-title
              >
            </v-list-item>

            <v-list-item href="/shippingpolicy" class="white--text">
              <v-list-item-title class="white--text"
                >Shipping Policy</v-list-item-title
              >
            </v-list-item>

            <v-list-item href="/aboutus" class="white--text">
              <v-list-item-title class="white--text">About</v-list-item-title>
            </v-list-item>

            <v-list-item href="/contact-us" class="white--text">
              <v-list-item-title class="white--text"
                >Contact Us</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="mb-4">
          <h3 class="text-h6 mb-2 red--text">Social Link</h3>
          <div class="mb-2 white--text">Follow Us On Social Media</div>
          <v-row justify="start" class="social-icons mt-2">
            <v-btn
              icon
              href="https://www.facebook.com/sivakasicrackersz"
              class="mx-1"
              color="white"
            >
              <v-icon color="white">mdi-facebook</v-icon>
            </v-btn>
            <!-- <v-btn icon href="#" class="mx-1" color="white">
              <v-icon color="white">mdi-twitter</v-icon>
            </v-btn> -->
            <v-btn
              icon
              href="https://www.instagram.com/sivakasicrackersz"
              class="mx-1"
              color="white"
            >
              <v-icon color="white">mdi-instagram</v-icon>
            </v-btn>
            <v-btn
              icon
              href="https://www.youtube.com/@sivakasicrackersz"
              class="mx-1"
              color="white"
            >
              <v-icon color="white">mdi-youtube</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="mb-4">
          <h3 class="text-h6 mb-2 red--text">Where To Find Us</h3>

          <div
            class="mt-4"
            style="
              border-radius: 0px;
              overflow: hidden;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            "
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3936.018704374902!2d77.84221629999999!3d9.419760899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ed0e012d9160ef%3A0xa3d0268ad73fc5a3!2sSivakasi%20CrackersZ%20%E2%80%93%20Buy%20Crackers%20Online%20at%20Factory%20Price!5e0!3m2!1sen!2sin!4v1754898436777!5m2!1sen!2sin"
              width="100%"
              height="180"
              style="border: 0"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="mb-2 white--text text-center">
            COPYRIGHT © {{ new Date().getFullYear() }} RAJESWARI SOLUTION ALL
            RIGHTS RESERVED.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<style>
.footer-card {
  width: 100%;
}
.breadcrum-color a {
  color: #fff !important;
}
/* Footer and nav background color */
.footer-black {
  background-color: #000 !important;
}
.nav-black {
  background-color: #000 !important;
}
/* All text white */
.footer-black,
.footer-black * {
  color: #fff !important;
}
</style>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from "vuex";

import { VUE_WEB_BASEURL } from "../utils/api";

export default {
  name: "FooterCommon",
  data: () => ({
    imageUrl: "",
    menus: [
      {
        text: "FAQ",
        disabled: false,
        href: "/faq",
      },
      {
        text: "Privacy Policy",
        disabled: false,
        href: "/privacypolicy",
      },
      {
        text: "Terms And Condition",
        disabled: false,
        href: "/termsandcondition",
      },
    ],
  }),
  computed: {
    ...mapGetters(["getFooterDetails"]),
  },
  created() {
    this.fetchFooter();
    this.imageUrl = VUE_WEB_BASEURL;
  },
  methods: {
    ...mapActions(["fetchFooter"]),
    websiteOpen() {
      window.open("https://smartxpose.com/", "_blank");
    },
    locationOpen() {
      window.open("https://share.google/s8oJwVmxgnAqWg2Uy", "_blank");
    },
  },
};
</script>
